import type { Due, TaskStatus } from '../types/models';
import styles from './Pills.module.css';

const dueClass: Record<Due, string> = {
  overdue: styles.due_overdue,
  today: styles.due_today,
  soon: styles.due_soon,
  later: styles.due_later,
  '': styles.due_,
};

export function DuePill({ due, label }: { due: Due; label: string }) {
  return <span className={`${styles.duePill} ${dueClass[due]}`}>{label}</span>;
}

const STATUS_LABEL: Record<TaskStatus, string> = {
  todo: 'To do',
  doing: 'Doing',
  done: 'Done',
  stalled: 'Stalled',
};

const STATUS_CLASS: Record<TaskStatus, string> = {
  todo: styles.status_todo,
  doing: styles.status_doing,
  done: styles.status_done,
  stalled: styles.status_stalled,
};

export function StatusPill({ status, done }: { status: TaskStatus; done: boolean }) {
  const key = done ? 'done' : status;
  return (
    <span className={`${styles.statusPill} ${STATUS_CLASS[key]}`}>
      {done ? 'Done' : STATUS_LABEL[status]}
    </span>
  );
}
